/** Builds the public booking-page URL for a business from its slug. */
export function publicBookingUrl(origin: string, slug: string): string {
  return `${origin}/b/${slug}`;
}
